'use client';

import { Popover as HeroPopover } from '@heroui/react';
import { ReactNode } from 'react';

export interface PopoverProps {
  children: ReactNode;
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  placement?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end';
}

const PopoverRoot = ({
  children,
  isOpen,
  onOpenChange,
  placement,
}: PopoverProps) => {
  return (
    <HeroPopover
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      // @ts-ignore
      placement={placement}
    >
      {children}
    </HeroPopover>
  );
};

const Trigger = ({ children }: { children: ReactNode }) => (
  <HeroPopover.Trigger>{children}</HeroPopover.Trigger>
);

const Content = ({ children }: { children: ReactNode }) => (
  <HeroPopover.Content>{children}</HeroPopover.Content>
);

export const Popover = Object.assign(PopoverRoot, {
  Trigger,
  Content,
});
